import React from 'react';
import cn from 'classnames';
import SortIndicatorUpIcon from './icons/SortIndicatorUpIcon';
import SortIndicatorDownIcon from './icons/SortIndicatorDownIcon';

enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CustomSortIndicator = function CustomSortIndicator(_ref: any) {
  const sortOrder = _ref.sortOrder,
    className = _ref.className;
  const cls = cn('BaseTable__sort-indicator', className, {
    'BaseTable__sort-indicator--descending': sortOrder === SortOrder.DESC,
  });

  return React.createElement(
    'div',
    {
      className: cls,
      style: {},
    },
    sortOrder === SortOrder.DESC ? <SortIndicatorDownIcon /> : <SortIndicatorUpIcon />
  );
};

export { CustomSortIndicator, CustomSortIndicator as default };
